import {useMemo} from 'react';
import {PaymentsCart} from '@chekin/core';
import {getTotalPayNow} from '../cartUtils';
import {toNumber} from '../money';
import {findDepositPayment, getDepositFee} from '../paymentKinds';
import {usePaymentsEnv} from '../PaymentsEnv';

type Props = {
  paymentsCart?: PaymentsCart;
};
function useBuildTotalPayments({paymentsCart}: Props) {
  const {isBookingPaymentsActive} = usePaymentsEnv();

  const depositPaymentItem = findDepositPayment(paymentsCart);

  const depositFee = getDepositFee(paymentsCart, ['PRE_AUTH_PAYMENT']);
  const totalDepositAmount = toNumber(depositPaymentItem?.amount).toFixed(2);

  const totalToPayNow = useMemo(
    () =>
      getTotalPayNow({
        depositFee,
        amount: paymentsCart?.total_amount_to_pay,
        outsidePaidAmount: paymentsCart?.outside_paid_amount,
        isBookingPaymentsActive,
      }),
    [
      depositFee,
      paymentsCart?.total_amount_to_pay,
      paymentsCart?.outside_paid_amount,
      isBookingPaymentsActive,
    ],
  );

  return {
    totalToPayNow,
    totalDepositAmount,
  };
}

export {useBuildTotalPayments};
